import type { StoreApi } from 'zustand'

import { useProjectsStore } from '@modules/projects/stores/projects.store'
import { useWorkspacesStore } from '@modules/workspaces/stores/workspaces.store'

import type { WorkspaceStore } from './workspace.type'
import { resolveWorkspaceSettings } from './workspace.utils'

export function registerWorkspaceStoreSubscriptions(store: StoreApi<WorkspaceStore>): void {
  const syncWorkspaceSettings = () => store.setState({ workspace: resolveWorkspaceSettings() })

  useWorkspacesStore.subscribe((state) => state.currentWorkspace, syncWorkspaceSettings)
  useProjectsStore.subscribe((state) => state.projects.length, syncWorkspaceSettings)
}
